export default __webpack_public_path__ + "media/images/reticle-598f880539bfa93e3e2cc0fbb63afbf9.png";